import { constructionAsset, constructionSafety, logisticsAsset } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '집, 사무실, 또는 상점을 항상 직접 지켜보지 않고도 안전하게 유지할 수 있는 방법을 고민해 본 적 있으신가요? 그 답은 바로 감시 카메라입니다. 이 기술은 우리가 공간을 보호하고 관리하는 방식을 변화시키는 강력한 도구입니다. 감시 카메라는 보안, 효율적인 관리, 다양한 분야에서의 운영 최적화를 위해 필수적인 솔루션이 되었습니다. 그렇다면 감시 카메라란 무엇이며, 어떤 종류가 있고, 일상생활에서 어떻게 활용될까요? 이 글에서 자세히 알아보겠습니다!',
  keywords: '감시 카메라, 보안 카메라, 스마트 카메라, 기업용 감시 카메라, 가정용 감시 카메라',
  ogSite: '감시 카메라란 무엇인가요? 어떤 종류가 있나요?',
  title: '감시 카메라란 무엇인가요? 어떤 종류가 있나요?',
  ogUrl: 'https://orbro.io/blog/surveillanceCamera',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_E9HyIyurA3wY4r4Bj3myCITAvCzvaKZHIL5lgXbVwxPw5WjYZkIVo4hL06qoeAMdJRXHmqwfjZzrrhd9VMXVMkdPAMrYV0a3N-6wC2c3bvFVEXvdmQfeSiSowlTg8-Ymm7xqyw0VXnVRkiMOSIuTHNHnGmovPuhzRsmp9n2ZwnDMrQQLZUKNUmot-qBZXqE5XeeSRy3fw4d4ygJ0QPHuDFMpFDoMfdegcqGTDa2Gdn6fRPHiCE7C1Omvf9Rfo5I7ep_RbYPLnW7aV8CrlO0XVeLIUv7tJzueK3UYGYSNywmo8fcTkwVtsHuFRoPgpQpcS1RkjyE3gl_DFqg8pWmYjf1qOoYW8rFQIvFutOxJhRW09vNC-tMCL1BccPNSe5NJ5doVUx1B_nZeVso9go1ec2ldH3A210j-yzf3oVJPB9xgjE4e-N5yT3CYI_Yna-1nxzS_5IwLHjGp8SEoO-fTM8JecWpVhdZbKRj90lST5rCwUnp3o6l-PJsoZxJUV4FBIVuO0En3TZzJ89PFqEP2dL3_62zoCbpGr47E7AziUp3mQ3GOjPQHibCPEWqrcMQ71SZ_UFW_fqvFBkxfDrzgC61pTXAEMMoENLfnBZGCf9vE2rV222eWRICMyON5KPHpdg4-koec-Tcew_YYS7t5pl2ljGWuyBxVkjl1UVSCi-1W_oQRWlMVk-QNGIimAM1-39E7gbOqQOV8rKuthh8qjLjeioy0p9st9jHzx2O4ePQkzrMw3vZKhF-IzuAD5CCFHLuNmxP6fLdFaUH2RSaFq1hzI-pPjltRcxZ2kLzttUm5XueASBX7DlGVsn1F7x5_-eBsfMm_PCMR0E7eX5qtu3rWVmW0zfNT5sAcRDvW7CCGssx2TObWH0K4e0EWddIjs4Qj80sMtqbaEVcEu_tDJYiM1w5hE5qg1qLZAFCfCQ6LRZ8IZm56qxiA19JupvamIr2tLYZ6kAQ0udCwWoa77ieBAg4-z3hJ5ssLq0iPD0LGAJFS07Ryq2gZEjhEFnkNqUXtmbH5Kc1JU-g6TvyVRySKo3ANQjVNoxOoPE7F-0KMzZDbs7ueqKd4IQXt_rrQ9AEOC-I0qq3PiVyP1lI_HZprcEiwNdTRb27IfpsY6GNHzWM9bPTUl5US8DjdeVejGT2IR6TKZS9zsArMD5-VJhXma8Yxtik9mxzB17vtLLA8vTo7VGv2WsSbYX_SUEaYrMP_cxRdhf97C73u5kjWtpQuMrLxC7IakQGT4cPRK1-2jF7sWXqnhPhsNWR0KhTGTjLfrQ4JZjKmARPKbBuFL9eCcnmDsV5AwRySfoTPRzDb1zNuqKMNBQM_8appZZF0R8FBIioXkbVoMjONWw98DJUMbCSv9VSycv2w5YB6kpDvw8mhyIGqpsYA5geCNlp5qtv2QnGtP012tfxwJDudpjwurTY1oJbVMYdcr6TYRme9BzSrqKqNVW085lxIrwOlwXpmjxbAyBkRObfiNv78Msquk-IKlfUDbKohBbw4L4lhPvFF_lCyWUPZc00E7H5bvxMiRwwgj4ZfGpCpqAlDEBcpmlKW0R0EjUJQhAirD5fSLMlvS1cDrJsf5E8BrmWi4smy_eFZWaHb9L8lC7Bu6Lk6P2atyIbotkxXMl=w1406-h1418?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-06-21',
  tag1: '#감시카메라',
  tag2: '#보안카메라',
  tag3: '#스마트카메라',
  tag4: '#기업용감시카메라 #가정용감시카메라',
  text: [
    {
      head: '',
      subHead: '',
      desc: '집, 사무실, 또는 상점을 항상 직접 지켜보지 않고도 안전하게 유지할 수 있는 방법을 고민해 본 적 있으신가요? 그 답은 바로 감시 카메라입니다. 이 기술은 우리가 공간을 보호하고 관리하는 방식을 변화시키는 강력한 도구입니다. 감시 카메라는 보안, 효율적인 관리, 다양한 분야에서의 운영 최적화를 위해 필수적인 솔루션이 되었습니다. 그렇다면 감시 카메라란 무엇이며, 어떤 종류가 있고, 일상생활에서 어떻게 활용될까요? 이 글에서 자세히 알아보겠습니다!',
      dot: ''
    },
    {
      head: '1. 감시 카메라란 무엇인가?',
      subHead: '',
      desc: '감시 카메라는 특정 구역에서 이미지, 때로는 소리를 녹화하여 보안 모니터링이나 운영 관리를 가능하게 하는 전자 장치입니다. 단독으로 작동하거나 더 큰 시스템에 통합되어 스마트폰, 컴퓨터, 또는 중앙 모니터를 통해 실시간으로 확인하거나 녹화된 영상을 재생할 수 있습니다.\n\n오늘날의 감시 카메라는 단순히 영상을 녹화하는 데 그치지 않습니다. 인공지능(AI), 사물인터넷(IoT), 클라우드 기술을 통합하여 행동 분석, 얼굴 인식, 또는 즉각적인 경고 전송과 같은 스마트 카메라 기능을 제공합니다.\n\n예시: 주차장의 감시 카메라는 낯선 차량의 번호판을 인식하고 스마트폰으로 즉시 알림을 보냅니다.',
      dot: ''
    },
    {
      head: '2. 감시 카메라는 어떻게 작동하나?',
      subHead: '',
      desc: '감시 카메라는 스마트 비서와 같으며, 다음 세 가지 주요 단계를 통해 작동합니다.\n\n데이터 수집: 카메라는 렌즈와 센서를 통해 주변 환경의 이미지와 소리를 수집합니다.\n\n처리 및 저장: 데이터는 메모리 카드, 하드 드라이브, 또는 클라우드에 저장되며, 장치 설정에 따라 암호화됩니다.\n\n정보 전송: 이미지는 유선(동축 케이블, 이더넷) 또는 무선(Wi-Fi, 4G) 연결을 통해 사용자 장치로 전송됩니다.\n\n현대의 많은 감시 카메라는 움직임 감지, 얼굴 인식, 사람 수 계산과 같은 지능적 분석 기능을 통합하여 모니터링 효율성을 높이고 수동 개입을 최소화합니다.',
      dot: ''
    },
    {
      head: '3. 주요 감시 카메라 종류',
      subHead: '',
      desc: '감시 카메라는 개인부터 기업까지 다양한 요구를 충족하도록 설계된 여러 유형이 있습니다. 다음은 가장 일반적인 종류입니다.\n\n아날로그 카메라\n특징: 동축 케이블을 통해 영상 신호를 전송하며, DVR(디지털 비디오 레코더)에 연결됩니다.\n장점: 저렴한 비용, 쉬운 설치, 소규모 시스템에 적합\n단점: 화질이 제한적(보통 HD 이하), 스마트 기능 부족\n응용: 가정, 소규모 소매점, 소형 주차장\n\nIP 카메라(인터넷 프로토콜)\n특징: 인터넷을 통해 데이터를 전송하며, 고해상도(HD, Full HD, 4K)를 지원합니다.\n장점: 선명한 화질, AI 기능(얼굴 인식, 행동 분석) 통합, 원격 모니터링 용이\n단점: 비용이 더 높고, 안정적인 네트워크 대역폭 필요\n응용: 사무실, 공장, 쇼핑몰, 산업 단지\n\n무선 카메라(Wi-Fi)\n특징: Wi-Fi로 연결되며 복잡한 케이블이 필요 없고, 모바일 앱과 함께 제공됩니다.\n장점: 유연성, 이동 용이, 빠른 설치\n단점: Wi-Fi 신호에 의존하며, 네트워크가 약하면 연결이 끊길 수 있음\n응용: 가정용 감시 카메라, 소규모 사무실, 임시 공간\n\nPTZ 카메라(Pan-Tilt-Zoom)\n특징: 좌우 회전, 상하 기울기, 줌인/줌아웃이 가능하며 원격 제어 가능합니다.\n장점: 넓은 구역 모니터링, 유연성, 대규모 공간에 적합\n단점: 높은 비용, 정기적인 유지보수 필요\n응용: 공항, 항만, 대형 창고, 공공 장소\n\n열화상 카메라(Thermal Camera)\n특징: 적외선 기술로 온도를 감지하며, 어둠이나 악천후에서도 효과적입니다.\n장점: 조명이 부족한 환경에서 효과적, 생명체 또는 기계 이상 감지\n단점: 이미지 세부 사항 부족, 높은 투자 비용\n응용: 국방 보안, 구조 작업, 고온 공장 모니터링\n\n360도 카메라\n특징: 360도 전방위 시야로 사각지대를 줄입니다.\n장점: 단일 장치로 전체 구역을 커버\n단점: 전용 소프트웨어로 이미지 처리가 필요\n응용: 강당, 대형 매장, 쇼핑 센터',
      dot: ''
    },
    {
      head: '4. 감시 카메라의 이점',
      subHead: '',
      desc: '감시 카메라 사용은 보안 보호부터 업무 최적화까지 탁월한 가치를 제공합니다.\n\n보안 강화\n지속적인 모니터링으로 침입, 도난, 파괴 행위를 방지합니다.\n예시: 건물 입구의 보안 카메라가 침입자를 감지하고 경보를 작동시킵니다.\n\n효율적인 관리\n직원, 고객, 운영 프로세스를 모니터링하여 성과를 최적화합니다.\n예시: 공장에서 감시 카메라는 생산 라인의 병목 현상을 감지합니다.\n\n증거 제공\n사고, 분쟁, 위반 상황에 대한 비디오를 저장하여 증거로 활용합니다.\n예시: 감시 카메라 영상은 교통 사고 분쟁 해결에 도움을 줍니다.\n\n비용 절감\n보안 요원이나 수동 모니터링 필요성을 줄여 장기적인 비용을 절감합니다.\n예시: 소매점은 야간 경비원 대신 감시 카메라를 사용하여 운영 비용을 줄입니다.\n\n고객 경험 향상\n고객 행동을 모니터링하여 서비스 개선 또는 공간 배치를 최적화합니다.\n예시: 쇼핑몰은 감시 카메라를 사용하여 제품 진열 구역을 최적화합니다.',
      dot: ''
    },
    {
      head: '5. 감시 카메라의 실제 응용',
      subHead: '',
      desc: '감시 카메라는 가정부터 대규모 산업까지 모든 곳에서 활용됩니다. 다음은 두드러진 응용 분야입니다.\n\n가정 보안\n집, 정원, 주차 구역을 도난으로부터 보호하고, 어린이나 노인을 모니터링합니다.\n예시: 한 가정은 가정용 감시 카메라를 사용하여 외출 중에도 스마트폰으로 집 정문을 확인합니다.\n\n기업 및 사무실\n직원, 고객, 사무실 자산을 모니터링하여 보안과 업무 효율성을 보장합니다.\n예시: 기술 회사는 기업용 감시 카메라 IP를 설치하여 민감한 데이터와 장비를 보호합니다.\n\n산업 및 제조\n생산 라인, 창고, 장비를 모니터링하여 문제를 감지하고 프로세스를 최적화합니다.\n예시: 공장은 PTZ 감시 카메라를 사용하여 대규모 생산 구역을 모니터링합니다.\n\n교통 및 운송\n교통 상황, 위반 감지, 또는 대중교통 수단을 모니터링하여 안전을 보장합니다.\n예시: 고속도로의 감시 카메라는 차량 속도를 기록하여 위반을 처리합니다.\n\n의료\n환자, 격리 구역, 의료 장비를 모니터링하여 안전과 절차 준수를 보장합니다.\n예시: 병원은 감시 카메라를 사용하여 중환자실을 원격으로 모니터링하여 의사를 지원합니다.\n\n교육\n학교 내 보안을 유지하고, 교실이나 공공 구역을 모니터링하여 학생을 보호합니다.\n예시: 대학교는 360도 감시 카메라를 설치하여 캠퍼스 사각지대를 줄입니다.\n\n소매 및 서비스\n고객 행동을 모니터링하고, 도난을 방지하며, 쇼핑 경험을 최적화합니다.\n예시: 슈퍼마켓은 AI 기반 스마트 카메라를 사용하여 출입 고객 수를 계산하고 피크 시간대를 관리합니다.\n\n공공 보안\n공원, 역, 공항과 같은 공공 장소를 모니터링하여 질서와 안전을 유지합니다.\n예시: 열화상 감시 카메라는 항만에서 야간에 비정상 물체를 감지합니다.',
      dot: ''
    },
    {
      head: '6. 적합한 감시 카메라 선택 방법',
      subHead: '',
      desc: '감시 카메라의 이점을 최대한 활용하려면 적합한 장치를 선택해야 합니다. 다음은 몇 가지 제안입니다.\n\n목적 정의: 가정, 사무실, 공장 등 용도에 따라 요구 사항이 다릅니다.\n\n해상도 선택: 얼굴 인식이 필요한 경우 최소 Full HD를 선택하세요.\n\n스마트 기능 우선: 움직임 감지, 얼굴 인식, 클라우드 연결 기능을 찾으세요.\n\n내구성 확인: 야외 설치 시 방수, 방진 기능을 갖춘 카메라를 선택하세요.\n\n예산 고려: 저렴한 아날로그, 무선 카메라와 고급 IP, PTZ, 열화상 카메라를 비교하세요.\n\n예시: 소규모 매장을 모니터링하려면 Wi-Fi 감시 카메라가 간편하고 비용 효율적입니다.',
      dot: ''
    },
    {
      head: '7. 결론',
      subHead: '',
      desc: '감시 카메라는 단순한 보안 도구가 아니라 가정, 사무실, 공장, 공공 장소에서 관리를 돕는 강력한 조력자입니다. 아날로그, IP, 무선, PTZ, 열화상, 360도 등 다양한 유형을 통해 자신의 필요에 맞는 장치를 쉽게 찾을 수 있습니다.\n\n지금 감시 카메라를 탐색하고 설치하여 더 안심하고, 더 효율적으로 일하며, 모든 것을 통제하세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '2',
    product: [
      {
        text: productPurchase.purchase.worker.workerTracking.title,
        title: productPurchase.purchase.worker.workerTracking.title,
        serial: productPurchase.purchase.worker.workerTracking.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.workerTracking.thumbnail,
      },
      {},
    ],
    solution: [
      {
        img: constructionAsset.thumb,
        data: 'constructionAsset',
        link: '/enterprise/construction/asset',
      },
      {
        img: constructionSafety.thumb,
        data: 'constructionSafety',
        link: '/enterprise/construction/safety',
      },
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
    ],
  },
};
